import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import axios from 'axios'
import { setToken } from '../token'
import { readGaIds, pushDataLayerEvent, trackSignUpOnce } from '../ga4'

const Callback = () => {
  const { isLoading, error, isAuthenticated, getAccessTokenSilently, user } = useAuth0()
  const history = useHistory()
  const [status, setStatus] = useState('initial')

  useEffect(() => {
    const sendTokenToBackend = async () => {
      try {
        console.log('Starting Auth0 callback...')
        const savedPlan = sessionStorage.getItem('target_plan')
        const savedPromo = sessionStorage.getItem('target_promo')
        console.log('DEBUG: Plan retrieved from storage on return:', savedPlan)
        const accessToken = await getAccessTokenSilently({
          audience: process.env.AUTH0_AUDIENCE,
          scope: 'openid profile email',
        })
        setStatus('sending')
        console.log('Sending token to backend...')
        // const data = await fetch(`${process.env.CORPORATE_URL}/auth/token-login/`, {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json'
        //   },
        //   body: JSON.stringify({ access_token: accessToken }),
        //   credentials: 'include'
        // })
        const res = await axios.post(
          `${process.env.CORPORATE_URL}/auth/token-login/`,
          { access_token: accessToken, target_plan: savedPlan, promo_code: savedPromo, ...readGaIds() },
          { withCredentials: true }
        )
        console.log('token-login res:', res.status, res.data)
        if (res.status >= 200 && res.status < 300) {
          sessionStorage.removeItem('target_plan')
          sessionStorage.removeItem('target_promo')
          setToken(res.data.token)
          // setStatus('redirecting')
          // history.replace('/')
          if (res.data.is_new_user) {
            await trackSignUpOnce((user && user.sub) || res.data.token, res.data.signup_method)
          }
          if (res.data.checkout_url) {
            setStatus('redirecting')
            await pushDataLayerEvent('begin_checkout')
            console.log('Diverting to Stripe Checkout:', res.data.checkout_url)
            window.location.href = res.data.checkout_url
          } else {
            setStatus('redirecting')
            history.replace('/')
          }
        } else {
          throw new Error('Failed to log in with token')
        }
      } catch (e) {
        console.error('Failed to send token to backend', e)
        setStatus('error')
      }
    }

    if (isAuthenticated && !isLoading) {
      sendTokenToBackend()
    }
  }, [isAuthenticated, isLoading, getAccessTokenSilently, history])

  if (isLoading) return <p>Loading user...</p>
  if (error) return <p>Oops: {error.message}</p>

  return <p>{status === 'redirecting' ? 'Redirecting...' : 'Processing login...'}</p>
}

export default Callback
